import axios from 'axios'

const qs = require('qs')

const state = {
  staffList: [],
  staffSingle: null,
}

const getters = {
  getStaffList (state) {
    return state.staffList
  },
  getStaffSingle (state) {
    return state.staffSingle
  },
}

const mutations = {
  setStaffList (state, payload) {
    state.staffList = payload
  },
  setStaffSingle (state, payload) {
    state.staffSingle = payload
  },
  clearSingleStaff (state) {
    state.staffSingle = null
  },
}

const actions = {
  fetchStaffList ({ commit, rootGetters }, meta) {
    return axios
      .get(
        `${rootGetters['api/staffList']}?limit=${meta.limit}&offset=${meta.offset}&page=${meta.page}`,
      )
      .then((res) => {
        commit('setStaffList', res.data.items)

        return res
      })
      // .catch((err) => err)
  },
  fetchSingleStaff ({ commit, rootGetters }, id) {
    return axios
      .get(rootGetters['api/staffSingle'](id))
      .then((res) => {
        commit('setStaffSingle', res.data.data)

        return res
      })
      .catch((err) => err)
  },
  createStaff ({ rootGetters }, data) {
    return axios
      .post(rootGetters['api/staffCreate'], data)
      .then((res) => {
        return res
      })
      // .catch((err) => err)
  },
  editStaff ({ rootGetters }, { data, id }) {
    return axios
      .put(rootGetters['api/staffEdit'](id), data)
      .then((res) => {
        return res
      })
      // .catch((err) => err)
  },
  deleteStaff ({ commit, getters, rootGetters }, id) {
    return axios
      .delete(rootGetters['api/staffDelete'](id))
      .then((res) => {
        if (res.status === 200) {
          const items = getters.getBranches.filter((val) => val.id !== id)
          commit('setStaffList', items)
        }

        return res
      })
      .catch((err) => err)
  },
  fetchCouriersInWork ({ getters, rootGetters }, payload = {}) {
    /* if (!payload.date) {
      payload.date = rootGetters['orders/getSelectedDate']
    } */
    const params = qs.stringify(payload, { arrayFormat: 'repeat', addQueryPrefix: true })
    return axios
      .get(`${rootGetters['api/couriersInWork']}${params}`)
      .then((res) => {
        return res.data.items
      })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
